
import Nav from "../../components/nav/Nav.vue";
import LotteryMore from "../../components/lottery/LotteryMore.vue";
import Prize from "../../components/lottery/Prize.vue";
import Exchange from "../../components/lottery/Exchange.vue";
import LuckyValue from "../../components/lottery/LuckyValue.vue";
import Algorithm from "../../components/lottery/Algorithm.vue";
import WinnersList from "../../components/lottery/WinnersList.vue";
import NotDrawToast from "../../components/lottery/NotDrawToast.vue";
import DrawAddressToast from "../../components/lottery/DrawAddressToast.vue";
import { Options, Vue } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { LotteryModel, WinnerModel } from "../../model/lottery/LotteryModel";
import { TimerFormatter } from "../../hooks/TimerFormatter";
import { openToast } from "toast-ts";
import { LotteryConfig } from "../../config/Lottery.conf";
@Options({
  components: {
    Nav,
    LotteryMore,
    Prize,
    Exchange,
    LuckyValue,
    Algorithm,
    WinnersList,
    NotDrawToast,
    DrawAddressToast
  }
})
export default class LotteryPage extends Vue {
  private navRights = [
    "../../assets/lottery/rule_icon.png",
    "../../assets/lottery/service_icon.png"
  ];
  private myLuckyTitle = "我的幸运码";
  /// 是否开奖 //-1:未中奖 0:未开奖 1:中奖 2:取消开奖 3:中奖并已经兑换过奖品
  private isDrawStatus = 0;
  private timer: string | null = "";
  private msg = "本期幸运码兑换截止到本周日零点";
  private dataModel: LotteryModel | null = null;
  private integral = 0;
  private isShowNotDrawToast = false;
  private isShowDrawAddressToast = false;
  private timerInterval: number | null = 0;
  mounted() {
    this.getPoints();
    this.getLotteryData();
  }

  getPoints() {
    Http.get<number>(Urls.getPoints).then(
      (res: number) => {
        this.integral = res;
      },
      (err: ResponseData) => {
        console.log("LotteryPage:", err.message);
        // openToast(err.message);
      }
    );
  }
  getLotteryData() {
    Http.get<LotteryModel>(Urls.lottery_curPhase).then(
      (res: LotteryModel) => {
        this.dataModel = res;
        LotteryConfig.minPerson = this.dataModel.minPerson;
        this.isDrawEvent();
        this.timer = TimerFormatter.lotteryTimerFormatter(
          this.dataModel.drawTime.toString()
        );
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_curPhase, err.message);
      }
    );
  }
  exchangeEvent(num: number) {
    Http.post<string>(Urls.lottery_exchange, { num: num }).then(
      () => {
        this.integral -= num * 100;
        openToast("兑换成功");
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_exchange, err.message);
        if (
          err.code == 22102 ||
          err.code == 22103 ||
          err.code == 22104 ||
          err.code == 20106
        ) {
          openToast(err.message);
        }
      }
    );
  }

  /// 和当前时间对比是否开奖
  isDrawEvent() {
    //  1、先根据时间判断，是否到开奖时间
    if (this.dataModel == null) return;
    const now = new Date();
    const drawTime = new Date(this.dataModel.drawTime.toString());
    // 还没到开奖时间
    if (now < drawTime) {
      // if (this.dataModel.status == 0) {
      this.isDrawStatus = 0;
      this.setIntervalReloadData();
    } else {
      // 到开奖时间了
      this.isDataDraw();
    }
  }
  // 距离开奖3分钟就倒计时
  setIntervalReloadData() {
    if (this.dataModel != null) {
      const drawTime = new Date(this.dataModel.drawTime.toString());
      const now = new Date();
      const seconds = drawTime.getTime() - now.getTime();
      console.log("seconds", seconds);
      if (seconds < 180000 && seconds > 0) {
        this.timerInterval = setInterval(() => {
          if (this.timerInterval != null) {
            clearTimeout(this.timerInterval);
          }
          this.getLotteryData();
        }, seconds + 3000);
      }
    }
  }

  isDataDraw() {
    // 2、根据后台判断，是否开奖
    if (this.dataModel == null) return;
    if (this.dataModel.status == 1) {
      // 开奖了
      this.isWinnerData();
    } else if (this.dataModel.status == -1) {
      // 取消开奖
      this.isDrawStatus = 2;
      this.msg = "本期已停止兑换幸运码";
    }
  }

  /// 是否中奖
  isWinnerData() {
    Http.post<WinnerModel>(Urls.lottery_isWinner, null).then(
      (res: WinnerModel) => {
        if (res.isWinner == false) {
          // 未中奖
          this.isDrawStatus = -1;
          this.notWinning(true);
        } else if (res.isWinner == true) {
          this.redeemPrizes(res.isTook);
        }
      },
      (err: ResponseData) => {
        this.isDrawStatus = -1;
        console.log(Urls.lottery_isWinner, err.message);
        // openToast("获取是否中奖失败");
      }
    );
  }

  // 是否兑换过奖品
  redeemPrizes(isRedeem: boolean) {
    if (isRedeem) {
      //兑换过奖品
      this.isDrawStatus = 3;
    } else {
      // 没有兑换过
      this.isDrawStatus = 1;
      this.defultWinning(true);
    }
  }
  pushMyLucky() {
    this.$router.push("/my/lucky");
  }
  viewRules() {
    this.$router.push("/lottery/rule");
  }
  call() {
    window.location.href = "tel://17331511136";
  }
  notWinning(value: boolean) {
    if (LotteryConfig.getShowWinningToast(LotteryConfig.notWinning)) {
      this.isShowNotDrawToast = value;
    }
  }

  winning(value: boolean) {
    this.isShowDrawAddressToast = value;
  }
  /// isAction：是否是点击，默认弹窗= false
  defultWinning(value: boolean) {
    if (LotteryConfig.getShowWinningToast(LotteryConfig.winning)) {
      this.isShowDrawAddressToast = value;
    }
  }
  reloadData() {
    this.isShowDrawAddressToast = false;
    this.isDrawStatus = 3;
  }
  playVideo() {
    this.$router.push("/video");
  }
  // clear() {
  //   const storage = window.localStorage;
  //   storage.clear();
  // }
}
